<template lang="pug">
VCard(variant="outlined")
  VListItem.py-2(
    :to="localePath({ params: { ...$route.params, type: commentaryTypeShortName } })"
  )
    template(#prepend)
      CommentaryTypeIcon(
        :color="$vuetify.theme.name === 'dark' ? 'secondary-c500' : 'secondary-c900'"
        :short-name="commentaryTypeShortName"
        variant="outline"
      )
    VListItemTitle {{ commentaryTypeName }}
    VListItemSubtitle(v-if="!!count")
      span(
        v-html="i18n.t('Commentary.comments', { count: count.countHtml }, count.countTotal)"
      )
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { CountData } from "./CommentaryType.util";
const localePath = useLocalePath();

const i18n = useI18n();

interface Props {
  /**
   * The (human-readable) name of the commentary type to switch to when clicking this component.
   */
  commentaryTypeName: string;

  /**
   * The short (machine-readable) name of the commentary type to switch to when clicking this component.
   */
  commentaryTypeShortName: string;

  count?: CountData;
}

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
  click: [value: string];
}>();
</script>
